import { ConsentCheckboxLabel } from "./ConsentCheckboxLabel.js";
import { useRef } from "react";
import { Trans } from "react-i18next";
import { Body1, Radio, Stack } from "@myphx-engineering/phx-design-system";
import { jsx, jsxs } from "react/jsx-runtime";

//#region src/client/components/shared/HipaaConsentRadioButtons.tsx
const HipaaConsentRadioButtons = ({ consent, isAttested, onCheckboxChange }) => {
	const isTouched = useRef(false);
	const handleCheckboxChange = (event) => {
		onCheckboxChange?.(consent.id, event.target.value === "accept");
		isTouched.current = true;
	};
	return /* @__PURE__ */ jsxs(Stack, {
		gap: "sm",
		children: [/* @__PURE__ */ jsx(Radio, {
			label: /* @__PURE__ */ jsx(ConsentCheckboxLabel, { consent }),
			checked: isAttested,
			value: "accept",
			onChange: handleCheckboxChange
		}), /* @__PURE__ */ jsx(Radio, {
			label: /* @__PURE__ */ jsx(Body1, { children: /* @__PURE__ */ jsx(Trans, {
				i18nKey: "hipaa.decline",
				ns: "cons",
				components: { 1: /* @__PURE__ */ jsx("strong", {}) }
			}) }),
			checked: !isAttested && isTouched.current,
			value: "decline",
			onChange: handleCheckboxChange
		})]
	});
};

//#endregion
export { HipaaConsentRadioButtons };